import Contact from "~/components/Contact";
import Footer from "~/components/Footer";
import PodHead from "~/components/Head";
import Navbar from "~/components/Navbar";

const ContactPage: React.FC = ({}) => {
  return (
    <>
      <PodHead title="Contact Us" />
      <main className="h-d-screen bg-gradient-to-t from-orange-400 via-orange-300 to-indigo-500">
        <div className="fixed left-0 right-0 top-0 z-10 w-full">
          <Navbar showLogo />
        </div>
        <div className="flex min-h-full flex-col justify-between gap-8 bg-base-100/50 backdrop-blur-sm">
          <div
            className="flex grow items-center justify-center p-0 md:p-8"
            id="episodes"
          >
            <div className="h-full pt-24">
              <Contact />
            </div>
          </div>

          <div className="w-full">
            <Footer />
          </div>
        </div>
      </main>
    </>
  );
};

export default ContactPage;
